<template>
  <div>
    <el-dialog title="打印销售单" :visible="printBoxVisible" append-to-body :modal-append-to-body="false" width="300px"
      @close="close">
      <div style="display: flex;flex-direction: column;align-items: center;">
        <div style="width: 100%;">
          <el-button @click="print('1')" style="width: 100%;">按当前排序打印销售单</el-button>
        </div>
        <div style="width: 100%;margin: 10px 0;">
          <el-button @click="print('2')" style="width: 100%;">按分拣箱排序打印销售单</el-button>
        </div>
        <div style="width: 100%;">
          <div class="header-name">按指定分拣箱打印销售单</div>
          <div class="box-list">
            <el-checkbox-group v-model="checkList">
              <el-checkbox v-for="box in boxListData" :key="box" :label="box"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div style="display: flex; justify-content: space-around;">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="print('3')">打印</el-button>
        </div>
      </template>

      <!-- 新增的打印内容选择对话框 -->
      <el-dialog title="选择打印内容" :visible="printContentDialogVisible" :close-on-click-modal="false" append-to-body :modal-append-to-body="false"
        width="400px" @close="handlePrintContentCancel">
        <div>
          <div style="padding: 20px 0 10px;">打印内容：</div>
          <el-select v-model="selectedPrintContent" placeholder="请选择打印内容" style="width: 100%; margin-bottom: 10px;">
            <el-option label="打印商品清单" value="printItemList"></el-option>
            <el-option label="打印包裹外包箱标签" value="printPackageLabel"></el-option>
          </el-select>
          <div v-if="selectedPrintContent === 'printPackageLabel'">
            <div style="padding: 20px 0 10px;">箱子总数：</div>
            <el-input-number v-model="boxTotal" placeholder="请输入箱子总数" :min="1" controls-position="right"
              style="width: 100%; margin-bottom: 10px;"></el-input-number>
            <div style="padding: 20px 0 10px;">备注：</div>
            <el-input v-model="remark" type="textarea" :rows="4" placeholder="请输入备注（限100字）" maxlength="100"
              show-word-limit style="width: 100%;"></el-input>
          </div>
        </div>
        <template slot="footer">
          <div style="display: flex; justify-content: space-around;">
            <el-button @click="handlePrintContentCancel">取消</el-button>
            <el-button type="primary" @click="handlePrintContentConfirm">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </el-dialog>


  </div>
</template>

<script>
export default {
  props: {
    customerName: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      printBoxVisible: true,
      boxListData: [],
      checkList: [],
      // 新增的数据属性
      printContentDialogVisible: false,
      selectedPrintContent: 'printItemList',
      boxTotal: 1,
      remark: '',
      currentType: ''
    }
  },
  methods: {
    setCheckList(list) {
      this.boxListData = list
    },
    print(type) {
      this.currentType = type
      if ((type == 2 || type == 3) && this.boxListData.some(item => item == '0')) {
        return this.$message.error('当前存在未分配分拣箱（0号箱），请先分配再打印！')
      }
      if (type == 1) {
        this.$emit('print', type, this.checkList)
      } else {
        // 显示新的打印内容选择对话框
        this.printContentDialogVisible = true
      }
    },
    close() {
      this.$emit('close')
    },
    // 新增的方法
    handlePrintContentConfirm() {
      if (this.selectedPrintContent === 'printPackageLabel' && !this.boxTotal) {
        return this.$message.error('请输入箱子总数')
      }
      if (this.selectedPrintContent === 'printPackageLabel') {
        // 生成包含所有箱号标签的HTML内容
        const labels = [];
        for (let i = 0; i < this.boxTotal; i++) {
          labels.push(`
            <div class="label">
              <div class="marginSet">发货方：${this.$cookies.get('agentname')}</div>
              <div class="marginSet">收货方：${this.customerName}</div>
              <div class="marginSet">共计箱数：${this.boxTotal} 箱</div>
              <div class="marginSet">本箱为第：${i + 1} 箱</div>
              <div class="marginSet">辛苦您在收货时仔细检查外包装完整性，如发现破损或异常请当场反馈。</div>
              <div class="marginSet">备注：${this.remark}</div>
            </div>
          `);
        }

        const htmlContent = `
          <html>
            <head>
              <style>
                /* 打印样式 */
                @media print {
                  body {
                    margin: 0 !important;
                    width: 70mm;    /* 纸张宽度 */
                    height: 130mm;  /* 纸张高度 */
                  }
                  .label {
                    width: 65mm;    /* 预留边距 */
                    height: 125mm;  /* 预留边距 */
                    page-break-after: always;
                    font-size: 10pt;  /* 推荐打印字号 */
                  }
                  .marginSet {
                    margin: 3mm 0mm;
                  }
                }

                /* 屏幕预览样式 */
                body {
                  margin: 0;
                  background: #f5f5f5;
                }
                .label {
                  width: 65mm;
                  height: 125mm;
                  border: 1px dashed #999;
                  padding: 2mm;
                  box-sizing: border-box;
                  font-family: Arial;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }
                .marginSet {
                  margin: 3mm 0mm;
                }
              </style>
            </head>
            <body>
              ${labels.join('')}
            </body>
          </html>
        `;

        // 创建新窗口并打印
        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        // 延迟确保内容加载完成
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 500);
      }
      if (this.selectedPrintContent === 'printItemList') {
        this.$emit('print', this.currentType, this.checkList)
      }
      this.handlePrintContentCancel()
    },
    handlePrintContentCancel() {
      this.printContentDialogVisible = false
      this.selectedPrintContent = ''
      this.boxTotal = 1
      this.remark = ''
    }
  }
}
</script>

<style scoped>
.sorting-box-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
}

.sorting-box {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.sorting-box>>>.el-input--small .el-input__inner {
  padding: 0;
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.header-name {
  line-height: 40px;
  text-align: center;
  background-color: #409eff;
  color: #FFF;
}

.box-list {
  border: 1px solid #eeeeee;
  border-top: none;
  padding: 10px;
}

.box-list>>>.el-checkbox+.el-checkbox {
  margin-left: 0;
  margin-right: 15px;
}

.box-list>>>.el-checkbox {
  margin-left: 0;
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/sortingBoxPrint.vue